// 菜单路由表
export const websiteRouter = [
  {
    path: "/",
    name: "website",
    component: resolve => require(["@/page/website/zscloud/zscloud"], resolve),
    children: [
      
      // 首页
      {
        path: "/",
        name: "products",
        meta : { title: "GPUEZ智算云 | 弹性、好用、省钱。租GPU就上ZSCloud" },
        // component: resolve => require(["@/page/website/zscloud/homeIndex/products"], resolve)
        component: resolve => require(["@/page/website/zscloud/products/slMarket/mktlist"], resolve),
      },

      // GPU算力云
      {
        path: "/zscloud/gpus",
        name: "gpusIndex",
        meta : { title: "GPUEZ智算云 - GPU算力云" },
        component: resolve => require(["@/page/website/zscloud/gpus/index"], resolve),
        children: [
          {
            path: "/zscloud/gpus/intro",
            name: "intro",
            meta : { title: "GPUEZ智算云 - 算力介绍" },
            component: resolve => require(["@/page/website/zscloud/gpus/intro"], resolve),
          },
          {
            path: "/zscloud/gpus/privately",
            name: "privately",
            meta : { title: "GPUEZ智算云 - 算力私有化" },
            component: resolve => require(["@/page/website/zscloud/gpus/privately"], resolve),
          },

          {
            path: "/zscloud/gpus/companyslcebter",
            name: "privately",
            meta : { title: "GPUEZ智算云 - 企业算力中心" },
            component: resolve => require(["@/page/website/zscloud/gpus/companyslcebter"], resolve),
          },

          // {
          //   path: "/zscloud/gpus/AIserver",
          //   name: "AIserver",
          //   meta : { title: "GPUEZ智算云 - AI服务器" },
          //   component: resolve => require(["@/page/website/zscloud/gpus/AIserver"], resolve),
          // },
        ],
        redirect: "/zscloud/gpus/intro"
      },
      
      // 应用市场
      {
        path: "/zscloud/appmarket",
        name: "appmarket",
        meta : { title: "GPUEZ智算云 - 应用市场" },
        component: resolve => require(["@/page/website/zscloud/mirrorCenter/index"], resolve),
      },

            
      // DeepSeek
      {
        path: "/zscloud/deepseek",
        name: "deepseek",
        meta : { title: "GPUEZ智算云 - deepseek" },
        component: resolve => require(["@/page/website/zscloud/deepseek/index"], resolve),
      },
        
      // GPU算力云 - shop
      {
        path: "/zscloud/slMarket",
        name: "slMarket",
        meta : { title: "GPUEZ智算云 - 算力市场" },
        component: resolve => require(["@/page/website/zscloud/products/slMarket/slMarket"], resolve),
        children: [
          {
            path: "/zscloud/slMarket/mktlist",
            name: "mktlist",
            meta : { title: "GPUEZ智算云 - 算力市场" },
            component: resolve => require(["@/page/website/zscloud/products/slMarket/mktlist"], resolve),
          },
          {
            path: "/zscloud/slMarket/mktPackage",
            name: "mktPackage",
            meta : { title: "GPUEZ智算云 - 算力套餐" },
            component: resolve => require(["@/page/website/zscloud/products/slMarket/mktPackage"], resolve),
          },
          {
            path: "/zscloud/slMarket/payg",
            name: "payg",
            meta : { title: "GPUEZ智算云 - 算力市场 - 创建实例" },
            component: resolve => require(["@/page/website/zscloud/products/slMarket/payg"], resolve),
          },
          {
            path: "/zscloud/slMarket/paygTotal",
            name: "paygTotal",
            meta : { title: "GPUEZ智算云 - 算力市场 - 整机租赁" },
            component: resolve => require(["@/page/website/zscloud/products/slMarket/paygTotal"], resolve),
          },
          {
            path: "/zscloud/slMarket/paygMetal",
            name: "paygMetal",
            meta : { title: "GPUEZ智算云 - 算力市场 - 裸金属" },
            component: resolve => require(["@/page/website/zscloud/products/slMarket/paygMetal"], resolve),
          },
          {
            path: "/zscloud/slMarket/mktIndex",
            name: "mktIndex",
            meta : { title: "GPUEZ智算云 - 活动专区" },
            component: resolve => require(["@/page/website/zscloud/products/slMarket/mktIndex"], resolve),
          },
          {
            path: "/zscloud/slMarket/mktCoupon",
            name: "mktCoupon",
            meta : { title: "GPUEZ智算云 - 优惠券专区" },
            component: resolve => require(["@/page/website/zscloud/products/slMarket/mktCoupon"], resolve),
          },

        ],
        redirect: "/zscloud/slMarket/mktlist"
      },
      
      // zscloud
      {
        path: "/zscloud/zsc",
        name: "",
        meta : { title: "GPUEZ智算云 - zscloud" },
        component: resolve => require(["@/page/website/zscloud/gpus/index"], resolve),
        children: [
          {
            path: "/zscloud/dispersed",
            name: "dispersed",
            meta : { title: "GPUEZ智算云 - 分布式云存储" },
            component: resolve => require(["@/page/website/zscloud/products/zsc/index"], resolve),
          },
          {
            path: "/zscloud/privateCloud",
            name: "privateCloud",
            meta : { title: "GPUEZ智算云 - 私有云存储" },
            component: resolve => require(["@/page/website/zscloud/solveOption/solveOption"], resolve),
          },
          {
            path: "/zscloud/smartTerminal",
            name: "smartTerminal",
            meta : { title: "GPUEZ智算云 - 智能终端" },
            component: resolve => require(["@/page/website/zscloud/products/smartTerminal/SmartTerminal"], resolve),
          },
          {
            path: "/zscloud/serverTrust",
            name: "serverTrust",
            meta : { title: "GPUEZ智算云 - 服务器托管" },
            component: resolve => require(["@/page/website/zscloud/products/serverOp/trusteeship"], resolve),
          },
          {
            path: "/zscloud/serverLease",
            name: "serverLease",
            meta : { title: "GPUEZ智算云 - 服务器租赁" },
            component: resolve => require(["@/page/website/zscloud/products/serverOp/lease"], resolve),
          },
        ],
        redirect: "/zscloud/dispersed"
      },

      // 解决方案
      {
        path: "/zscloud/solveIndex",
        name: "solveIndex",
        meta : { title: "GPUEZ智算云 - 解决方案" },
        component: resolve => require(["@/page/website/zscloud/solveOption/index"], resolve),
        children: [
          {
            path: "/zscloud/solveIndex/solveControl",
            name: "solveControl",
            meta : { title: "GPUEZ智算云 - 解决方案 - 监控云" },
            component: resolve => require(["@/page/website/zscloud/solveOption/solveControl"], resolve),
          },{
            path: "/zscloud/solveIndex/solveOne",
            name: "solveOne",
            meta : { title: "GPUEZ智算云 - 解决方案 - 一体机" },
            component: resolve => require(["@/page/website/zscloud/solveOption/solveOne"], resolve),
          },{
            path: "/zscloud/solveIndex/movieHome",
            name: "movieHome",
            meta : { title: "GPUEZ智算云 - 解决方案 - 家庭影院" },
            component: resolve => require(["@/page/website/zscloud/solveOption/movieHome"], resolve),
          },
        ],
        redirect: "/zscloud/solveIndex/solveOption"
      },

      // 新闻列表
      {
        path: "/zscloud/newslist",
        name: "newslist",
        meta : {
          title: "GPUEZ智算云 - 新闻列表"
        },
        component: resolve => require(["@/page/website/zscloud/news/newslist"], resolve),
      },

      // 新闻详情
      {
        path: "/zscloud/newsDetail",
        name: "newsDetail",
        meta : {
          title: "GPUEZ智算云 - 新闻详情"
        },
        component: resolve => require(["@/page/website/zscloud/news/newsDetail"], resolve),
      },

      // 帮助文档
      {
        path: "/zscloud/helpDoc",
        name: "helpDoc",
        meta : {
          title: "GPUEZ智算云 - 帮助文档"
        },
        component: resolve => require(["@/page/website/zscloud/helpDoc/index"], resolve),
      },

      // 关于智算云
      {
        path: "/zscloud/aboutUs",
        name: "aboutUsIndex",
        meta : {
          title: "GPUEZ智算云 - 公司简介"
        },
        component: resolve => require(["@/page/website/zscloud/aboutUs/index"], resolve),
        children: [
          {
            path: "/zscloud/aboutUs/know",
            name: "know",
            meta : { title: "GPUEZ智算云 - 了解智算云" },
            component: resolve => require(["@/page/website/zscloud/aboutUs/know"], resolve),
          },
          {
            path: "/zscloud/aboutUs/join",
            name: "join",
            meta : { title: "GPUEZ智算云 - 加入我们" },
            component: resolve => require(["@/page/website/zscloud/aboutUs/join"], resolve),
          },
          {
            path: "/zscloud/aboutUs/xyzm",
            name: "xyzm",
            meta : { title: "GPUEZ智算云 - 校园招募" },
            component: resolve => require(["@/page/website/zscloud/aboutUs/xyzm"], resolve),
          },
        ],
        redirect: "/zscloud/aboutUs/know"
      },

      // 购买产品
      {
        path: "/zscloud/buygoods",
        name: "buygoods",
        meta : {
          title: "GPUEZ智算云 - 购买产品"
        },
        component: resolve => require(["@/page/website/zscloud/products/buygoods/buygoods"], resolve),
      },

      // 推广返现
      {
        path: "/zscloud/tkfxUrl",
        name: "tkfxUrl",
        meta : {
          title: "GPUEZ智算云 - 注册享券"
        },
        component: resolve => require(["@/page/website/zscloud/extend/tkfxUrl"], resolve),
      },

      // 用户协议
      {
        path: "/zscloud/agreement",
        name: "UserAgreement",
        meta : {
          title: "GPUEZ智算云 - 用户协议"
        },
        component: resolve => require(["@/page/website/zscloud/extend/UserAgreement"], resolve),
      },

      //测试申请
      {
        path: "/zscloud/testing",
        name: "testing",
        meta : {
          title: "GPUEZ智算云 - 测试申请"
        },
        component: resolve => require(["@/page/website/zscloud/testing/index.vue"], resolve),
      },

      // 定价中心
      {
        path: "/zscloud/pricing",
        name: "pricing",
        meta : {
          title: "GPUEZ智算云 - 定价"
        },
        component: resolve => require(["@/page/website/zscloud/products/pricing/pricing"], resolve),
      },
      
    ],
    redirect: "/"
  }
]



// WEBPACK FOOTER //
// ./src/router/modules/websiteRouter.js